import {
  Component,
  ChangeDetectionStrategy,
  Input,
  Output,
  EventEmitter,
  ElementRef,
  ViewChild,
  SimpleChanges,
  OnChanges,
} from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { StaticMessage } from '@shared/enums';
import { DprApprover } from '@shared/models/dpr';
import { filter, Observable, take, tap } from 'rxjs';

@UntilDestroy()
@Component({
  selector: 'app-dpr-approver',
  templateUrl: './dpr-approver.component.html',
  styleUrls: ['./dpr-approver.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DprApproverComponent implements OnChanges {
  @Input({ required: true }) dprApprover: DprApprover;
  @Input({ required: true }) canEdit: boolean;
  @Input() isEditMode?: boolean;
  @Input({ required: true }) approverSaved$: Observable<boolean>;
  @Output() save = new EventEmitter<DprApprover>();
  @Output() delete = new EventEmitter<DprApprover>();

  @ViewChild('nameInput') inputElement: ElementRef;

  editedName: string;
  isEditModeOn = false;

  StaticMessage: typeof StaticMessage = StaticMessage;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes?.isEditMode?.currentValue) {
      this.isEditModeOn = changes.isEditMode.currentValue ?? false;
    }
    if (changes?.dprApprover?.currentValue) {
      this.editedName = changes.dprApprover.currentValue.name;
    }
  }

  enterEditMode(): void {
    if (!this.canEdit) {
      return;
    }

    this.isEditModeOn = true;
    setTimeout(() => {
      this.inputElement.nativeElement.focus();
    });
  }

  onSave(): void {
    this.save.emit({
      ...this.dprApprover,
      name: this.editedName,
    });

    this.approverSaved$
      .pipe(
        untilDestroyed(this),
        take(1),
        filter((saved) => saved),
        tap(() => {
          this.isEditModeOn = false;
        })
      )
      .subscribe();
  }

  onDelete(): void {
    this.delete.emit(this.dprApprover);
  }
}
